const allowedKeys = [
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "Tab",
  "Home",
  "End",
];
const beforeInput = (e, checkType, status) => {
  if (allowedKeys.includes(e.key)) return;
  const input = e.target; // <input />
  const value = input.value;
  if (e.which !== 8) {
    // Allow control keys
    if (
      checkType === "number" ||
      checkType === "negativeNumber" ||
      checkType === "bothNumber"
    ) {
      // Allow numbers (0–9)
      if (/^[0-9]$/.test(e.key)) return;
      if (
        e.key === "-" &&
        (checkType === "negativeNumber" || checkType === "bothNumber")
      ) {
        if (value.includes("-") || input.selectionStart !== 0) {
          e.preventDefault();
        }
        return;
      }
      e.preventDefault();
    } else if (checkType === "zip_code") {
      // Allow letters, numbers (0–9) and spaces
      if (/^[A-Za-z0-9 ]$/.test(e.key)) return;
      // Allow numbers -
      if (e.key === "-") {
        if (value.includes("-")) {
          e.preventDefault();
        }
        return;
      }
      e.preventDefault();
    }
  }
};

// A text input whose value is trimmed when the user leaves it (not a password)
const isTrimmable = (target) =>
  !!target && typeof target.value === "string" && target.type !== "password";

export const withTrimHandler = (handlerFn, checkType = null) => {
  const base = handlerFn();
  let temp = { ...base };
  if (!!checkType) {
    temp["onKeyDown"] = (e) => beforeInput(e, checkType, "onKeyDown");
    // Leaving the field trims it, and the form gets the trimmed text too (not
    // only what the input shows), so "  Ann " is saved as "Ann"
    temp["onBlur"] = (e) => {
      const target = e?.target;
      if (isTrimmable(target)) {
        const trimmed = target.value.trim();
        if (trimmed !== target.value) {
          target.value = trimmed;
          base?.onChange?.({ target: { value: trimmed, name: target.name } });
        }
      }
      base?.onBlur?.(e);
    };
  }
  return temp;
};
